import { Gtm, isWebBridgeSupported } from '@shopee-user/platform';
import {
  TrackingDataFieldTypeSignupMethod,
  TrackingDataFieldTypeAccountType,
} from '@shopee-user/tracking-signup';
import { AuthenticationSource } from '@shopee-user/with-web-view';
import { hashUserId } from './utils';
import { monitor } from '../../platform/monitoring';
import { BusinessPerfMetric } from '../../platform/monitoring/performance/enums';
// TODO @tranct gradually migrate tracking signup logic to this module
/**
 * Send the signup success event to GTM
 * https://docs.google.com/document/d/1-PbXIrCYMxYbfzQlZDtLbs2NHv-fDJKJh7nRUkK1R2g
 */
export const sendGTMEventSignupSuccess = ({
  userId,
  method,
  accountType,
}: {
  userId: number;
  method: TrackingDataFieldTypeSignupMethod;
  accountType: TrackingDataFieldTypeAccountType;
  autoMarkAsSent?: boolean;
}) => {
  Gtm.pushEvent({
    event: 'sign_up',
    // User ID is hashed to protect user privacy
    user_id: hashUserId(userId),
    account_type: accountType,
    register_channel: method,
  });
  monitor.sendDuration({
    name: BusinessPerfMetric.GTMEventReport,
    duration: 0,
    data: {
      event: 'sign_up',
      account_type: accountType,
      register_channel: method,
    },
  });
};

/**
 * @deprecated
 * Currently only used for SPX GTM/GA4 tracking feature
 * And SPX will track signup success event via webViewLoginSuccessfully, because all "signup" scenarios will go through webViewLoginSuccessfully eventually.
 * We still keep this because need to support old SPX app
 */
export const sendWebViewEventSignupSuccess = ({
  userId,
  method,
  accountType,
  notifyCommand,
}: {
  userId: number;
  method: TrackingDataFieldTypeSignupMethod;
  accountType: TrackingDataFieldTypeAccountType;
  notifyCommand: (params: {
    fromSource: AuthenticationSource;
    data: Record<string, any>;
  }) => void;
}) => {
  if (isWebBridgeSupported()) {
    notifyCommand({
      fromSource: AuthenticationSource.Signup,
      data: {
        userId,
        hashedUserId: hashUserId(userId),
        registerChannel: method,
        accountType,
      },
    });
  }
};
